import { Component } from '@angular/core';

@Component({
  selector: 'invalid-invitation',
  templateUrl: './invalid-invitation.component.html',
  styleUrls: ['./invalid-invitation.component.scss'],
})
export class InvalidInvitationComponent {
}
